import { render, staticRenderFns } from "./orderHistory.vue?vue&type=template&id=72885201&scoped=true&"
import script from "./orderHistory.vue?vue&type=script&lang=js&"
export * from "./orderHistory.vue?vue&type=script&lang=js&"
import style0 from "./orderHistory.vue?vue&type=style&index=0&id=72885201&scoped=true&lang=css&"
import style1 from "./orderHistory.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72885201",
  null
  
)

export default component.exports